export enum SystemRoles {
  MANAGER = 'MANAGER',
  UNAUTHORIZED = 'UNAUTHORIZED'
}

export interface IUser {
  name: string;
  email: string;
  role?: any;
}